import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { getUserContext } from 'selectors/user/userSelectors';
import experimentFlags, { EDIT_PAGE_FORM } from '../../../../util/experimentFlags';
import { WEBSITE_PAGE_TYPES as PAGE_TYPES } from '../util/pageTypes';
import WebsitePreview from './WebsitePreview';

const mapStateToProps = state => {
  const page = state.website.pages.byId[state.website.pages.activePage.id];
  const pageType = page && page.type;
  const homePageFormSelector = formValueSelector('homepageSection');
  const weddingInfoFormSelector = formValueSelector('weddingInfoForm');
  const isHome = page && page.type === PAGE_TYPES.HOME;
  const showStickyPreview = isHome || (page && page.type === PAGE_TYPES.EVENT);
  const { date, wedding = {}, account = {} } = weddingInfoFormSelector(
    state,
    'date',
    'hashtag',
    'wedding',
    'account'
  );

  const getFormValues = () => {
    const userContext = getUserContext(state);
    const editPageFormFlag = experimentFlags.getFlag(EDIT_PAGE_FORM, userContext);

    const getFormIdentifier = () => {
      return (pageType && `${pageType.toLowerCase()}EditPageForm`) || 'EditPageForm';
    };

    const cmsPageFormIdentifier = getFormIdentifier();
    const cmsPageFormSelector = formValueSelector(cmsPageFormIdentifier);

    return editPageFormFlag
      ? {
          title: state.website.websitePreview.title,
          description: state.website.websitePreview.description,
          hidden: state.website.websitePreview.hidden,
          header_image_url: state.website.websitePreview.header_image_url,
        }
      : cmsPageFormSelector(state, 'title', 'description', 'hidden', 'header_image_url');
  };

  return {
    isHome,
    values: isHome
      ? homePageFormSelector(state, 'title', 'header_image_url', 'footer_image_url', 'nav_title')
      : getFormValues(),
    activePage: page,
    pages: state.website.pages.orderedIds.map(id => state.website.pages.byId[id]),
    wedding: state.wedding.wedding,
    weddingValues: isHome
      ? {
          date,
          hashtag: wedding.hashtag,
          title: wedding.title,
          city: account.city,
          stateProvince: account.state_province,
        }
      : null,
    account: state.wedding.account,
    pageComponentKey: pageType,
    showStickyPreview,
  };
};

const WebsitePreviewContainer = connect(mapStateToProps)(WebsitePreview);

export default WebsitePreviewContainer;
